import * as React from 'react'

import { TypographyWrapper } from './styles'

export interface TypographyProps {
  variant: string
  classNames?: string
  bold?: boolean
  children?: React.ReactNode
}

const Typography: React.FC<TypographyProps> = ({ variant, classNames, bold, children }) => {
  return (
    <TypographyWrapper id="nova-shared-Typography-root" className={`${variant} ${classNames} ${bold ? ' bold' : ''}`}>
      {children}
    </TypographyWrapper>
  )
}

export default Typography
